export default{
    install(Vue) {
        Vue.config.globalProperties.$addLineBreak = function(str) {
            if (!str) return ""
            let computed = str.replaceAll("\\n", "<br>")
            computed = computed.replaceAll("\n", "<br>")
            return computed
        }
    }
}